import React, { Fragment, useState, useEffect, PropsWithChildren } from "react";
import Dashboard from "./Dashboard";
import DashboardOptions from "./DashboardOptions";
import SelectedFilters from "./SelectedFilters";
import SaveDashboard from "./SaveDashboard";
import ShareDashboard from "./shareDashboard";
import ManageDashboard from "./ManageDashboards";
import { sidebarLibrary } from "./sidebarLibrary";
import { widgetLibrary } from "./widgetLibrary";
import WidgetSelection from "./WidgetSelection";

import { useSelector } from "react-redux";
import { getDialogSelector, updateShareVisible } from "../Slices/DialogSlice";
import { useAppDispatch } from "../../Core/store.hooks";

import uuid from "react-uuid";
import {
  ActionsLayout,
  Window,
  WindowActionsBar,
} from "@progress/kendo-react-dialogs";
import { uniq, map, flatten } from "lodash";

interface DashboardContainerProps {
  positionData: any;
  sidebarItems?: any;
  defaultWidgets?: any | null;
  noSidebar?: boolean;
  addRemove?: boolean;
  currentDashboard?: string;
  savable?: boolean;
  staticContent?: any;
    customSize?: any;
    multiDeviceWidgets?: any;
}

const DashboardContainer = (
  props: PropsWithChildren<DashboardContainerProps>
) => {
  // const showDashboardTitle = useSelector(getShowDashboardSelector);

  const [savedPositionData, updateSavedPositionData] = useState([
    { col: 1, colSpan: 3, rowSpan: 3 },
  ]);
  const [resetCounter, updateResetCounter] = useState(0);
  const [exportCounter, updateExportCounter] = useState(0);
  const [visible, setVisible] = React.useState<boolean>(false);
    const [saveVisible, updateSaveVisible] = useState(false);
    const [manageVisible, updateManageVisible] = useState(false);
  const [currentWidgets, updateCurrentWidgets] = useState(props.defaultWidgets);
  const [currentStaticContent, updateCurrentStaticContent] = useState([]);
  const [addedStaticContent, updateAddedStaticContent] = useState([]);
  const [addedWidgets, updateAddedWidgets] = useState([]);
  const [sidebarItems, updateSidebarItems] = useState([]);
  const [sidebarItemsInUse, updateSidebarItemsInUse] = useState([]);
  const [currentDashboard, updateCurrentDashboard] = useState("");

  const dispatch = useAppDispatch();
  const shareVisible = useSelector(getDialogSelector).shareVisible;

  useEffect(() => {
    if (props.currentDashboard != null)
      updateCurrentDashboard(props.currentDashboard);
  }, [props.currentDashboard]);
  useEffect(() => {
    updateSavedPositionData([...props.positionData]);
  }, []);

  useEffect(() => {
    updateSavedPositionData([...props.positionData]);
  }, [props.positionData]);

  useEffect(() => {
    createSidebarItems();
  }, [props.sidebarItems]);

  useEffect(() => {
      updateDefaultWidgets(props.defaultWidgets);
      updateAddedWidgets([]);
  }, [props.defaultWidgets]);
  useEffect(() => {
    if (props.staticContent != null && props.staticContent != undefined) {
      updateCurrentStaticContent(props.staticContent);
    }
  }, [props.staticContent]);

  const updateDefaultWidgets = (dws: any) => {
    if (currentWidgets == null || currentWidgets.length < 1) {
      if (dws != null) {
        updateCurrentWidgets(dws);
      }
    } else {
      updateCurrentWidgets([...dws]);
    }
  };

  const exportHandler = () => {
    updateExportCounter((exportCounter) => exportCounter + 1);
  };
  const resetHandler = () => {
    updateSavedPositionData(props.positionData);
    updateCurrentWidgets(props.defaultWidgets);
    updateCurrentStaticContent(
      props.staticContent != null ? props.staticContent : []
    );
    updateResetCounter((counter) => counter + 1);
  };
  const addHandler = () => {
    setVisible(true);
  };
  const repositionHandler = (e: any) => {
    updateSavedPositionData(e);
  };
  const saveHandler = () => {
    updateSaveVisible(true);
  };
    const manageHandler = () => {
        updateManageVisible(true);
    };
  const shareHandler = () => {
    shareVisible
      ? dispatch(updateShareVisible(false))
      : dispatch(updateShareVisible(true));
  };

  const dashboardOptions = {
    title: "Dashboard Options",
    item: (
      <DashboardOptions
        addRemove={props.addRemove}
        exportHandler={exportHandler}
        resetHandler={resetHandler}
        addWidget={addHandler}
        saveDashboard={saveHandler}
        shareDashboard={shareHandler}
        manageDashboard={manageHandler}
        savable={props.savable}
      />
    ),
    expanded: true,
  };
  const publishedFilters = {
    title: "Published Filters",
    item: <SelectedFilters />,
    expanded: false,
  };

  const removeWidget = (id: any) => {
    const newAddedWidgets = [];
    for (var i = 0; i < currentWidgets.length; i++) {
      if (currentWidgets[i].props.id != id) {
        newAddedWidgets.push(currentWidgets[i]);
      }
    }

    updateCurrentWidgets(newAddedWidgets);
  };
  const removeStatic = (id: any) => {
    const newAddedStatic = [];
    for (var i = 0; i < currentStaticContent.length; i++) {
      if (currentStaticContent[i].props.id != id) {
        newAddedStatic.push(currentStaticContent[i]);
      }
    }
    updateCurrentStaticContent(newAddedStatic);
  };

  const createSidebarItems = () => {
    if (!props.noSidebar) {
      if (props.sidebarItems != null) {
        updateSidebarItems([
          //   publishedFilters,
          ...props.sidebarItems,
          dashboardOptions,
        ]);
        updateSidebarItemsInUse(uniq(map(props.sidebarItems, "title")).sort());
      } else {
        updateSidebarItems([
          //publishedFilters,
          dashboardOptions,
        ]);
      }
    }
  };
  const addSidebarItem = (title: string) => {
    for (var i = 0; i < sidebarLibrary.length; i++) {
      if (sidebarLibrary[i].title == title) {
        return sidebarLibrary[i];
      }
    }
  };
  const addSidebarItems = (w: any) => {
    const newSidebarItems: string[] = [];
    const newSidebarItemsObjs: any = [];
    if (w) {
      for (var i = 0; i < w.length; i++) {
        if (w[i] != undefined) {
          if (
            sidebarItemsInUse.indexOf(w[i]) < 0 &&
            newSidebarItems.indexOf(w[i]) < 0
          ) {
            newSidebarItems.push(w[i]);
            newSidebarItemsObjs.push(addSidebarItem(w[i]));
            updateSidebarItemsInUse([...sidebarItemsInUse, w[i]]);
          }
        }
      }
      updateSidebarItemsInUse([...sidebarItemsInUse, ...newSidebarItems]);
      updateSidebarItems([...sidebarItems, ...newSidebarItemsObjs]);
    }
  };
  const addStaticFromHandler = (ws: any) => {
    if (ws.length > 0) {
      let newSidebarItems: any = [];
      const nws = ws.map((widget) => {
        return widget.component({ key: uuid() });
      });
      updateAddedStaticContent([...addedStaticContent, ...nws]);
      updateCurrentStaticContent([...currentStaticContent, ...nws]);
      for (var i = 0; i < ws.length; i++) {
        newSidebarItems = [...newSidebarItems, ...ws[i].sidebarItems];
      }
      addSidebarItems(newSidebarItems);
    }
  };
  const addWidgetsFromHandler = (ws: any) => {
    if (ws.length > 0) {
      let newSidebarItems: any = [];
      const nws = ws.map((widget) => {
        return widget.component({ key: uuid() });
      });
      updateAddedWidgets([...addedWidgets, ...nws]);
      updateCurrentWidgets([...currentWidgets, ...nws]);
      const newPosData: any = [];
      for (var i = 0; i < ws.length; i++) {
        newPosData.push({ col: 1, colSpan: 6, rowSpan: 3 });
        newSidebarItems = [...newSidebarItems, ...ws[i].sidebarItems];
      }
      addSidebarItems(newSidebarItems);
      updateSavedPositionData([...savedPositionData, ...newPosData]);
    }
  };
  const addGroupedWidgets = (gws: any) => {
    if (gws.length > 0) {
      const ws: any = [];
      const gwsIDs: any = [];
      const gwsPositionData: any = [];
      for (var i = 0; i < gws.length; i++) {
        gwsIDs.push(...gws[i].widgetIDs);
        gwsPositionData.push(...gws[i].positionArray);
      }
      for (var i = 0; i < gwsIDs.length; i++) {
        for (var k = 0; k < widgetLibrary.length; k++) {
          if (widgetLibrary[k].dashboardId == gwsIDs[i]) {
            ws.push(widgetLibrary[k]);
            break;
          }
        }
      }
      const newStaticContent: any = [];
      const newWidgets: any = [];
      for (var i = 0; i < ws.length; i++) {
        if (ws[i].static) {
          newStaticContent.push(ws[i]);
        } else {
          newWidgets.push(ws[i]);
        }
      }
      const nws = newWidgets.map((widget) => {
        return widget.component({ key: uuid() });
      });
      updateAddedWidgets([...nws, ...addedWidgets]);
      updateCurrentWidgets([...nws, ...currentWidgets]);
      let newSidebarItems: any = [];
      for (var i = 0; i < ws.length; i++) {
        newSidebarItems = [...newSidebarItems, ...ws[i].sidebarItems];
      }
      addSidebarItems(newSidebarItems);
      updateSavedPositionData([...gwsPositionData, ...savedPositionData]);
      addStaticFromHandler(newStaticContent);
    }
  };
  const addWidgetHandler = (ws: any) => {
    const newStaticContent: any = [];
    const newWidgets: any = [];
    const groupWidgets: any = [];
    for (var i = 0; i < ws.length; i++) {
      if (ws[i].isWidgetGroup) {
        groupWidgets.push(ws[i]);
      } else if (ws[i].static) {
        newStaticContent.push(ws[i]);
      } else {
        newWidgets.push(ws[i]);
      }
    }
    addWidgetsFromHandler(newWidgets);
    addStaticFromHandler(newStaticContent);
    //addGroupedWidgets(groupWidgets);
    setVisible(false);
  };
  const closeSaveWindow = () => {
    updateSaveVisible(false);
  };
    const closeManageWindow = () => {
        updateManageVisible(false);
    };
  const closeWindow = () => {
    setVisible(false);
  };
  return (
    <Fragment>
      {visible && (
        <Window
          title={"Add Widget"}
          onClose={closeWindow}
          initialHeight={700}
          initialWidth={1060}
          modal={true}
          minimizeButton={() => null}
        >
          <WidgetSelection
            currentWidgets={currentWidgets}
            addWidgetHandler={addWidgetHandler}
            closeWindow={closeWindow}
            currentStaticContent={currentStaticContent}
          />
        </Window>
      )}
      {saveVisible && (
        <Window
          title={"Save Dashboard"}
          onClose={closeSaveWindow}
          initialHeight={350}
          initialWidth={400}
          modal={true}
          minimizeButton={() => null}
        >
          <SaveDashboard
            staticContent={currentStaticContent}
            widgets={currentWidgets}
            positionData={savedPositionData}
            sidebarItems={sidebarItems}
            closeWindow={closeSaveWindow}
            currentDashboard={currentDashboard}
            customSize={props.customSize}
          />
        </Window>
          )}
          {manageVisible && (
              <Window
                  title={"Manage Dashboards"}
                  onClose={closeManageWindow}
                  initialHeight={800}
                  initialWidth={700}
                  modal={true}
                  minimizeButton={() => null}
              >
                  <ManageDashboard/>
                  <WindowActionsBar layout={"stretched"}>
                      <button
                          type="button"
                          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                          onClick={() => closeManageWindow()}
                          style={{ width: "150px" }}
                      >
                          Close
                      </button>
                  </WindowActionsBar>
              </Window>
          )}
      {shareVisible && (
        <Window
          title={"Share Dashboard"}
          onClose={shareHandler}
          initialHeight={350}
          initialWidth={400}
          modal={true}
          minimizeButton={() => null}
        >
          <ShareDashboard
            staticContent={currentStaticContent}
            widgets={currentWidgets}
            positionData={savedPositionData}
            sidebarItems={sidebarItems}
            closeWindow={shareHandler}
            currentDashboard={currentDashboard}
            customSize={props.customSize}
          />
        </Window>
      )}
      <Dashboard
        addRemove={props.addRemove}
        removeWidget={removeWidget}
        originalPositionData={props.positionData}
        savedPositionData={savedPositionData}
        sidebarItems={sidebarItems}
        exportCounter={exportCounter}
        resetCounter={resetCounter}
        widgets={currentWidgets}
        repositionHandler={repositionHandler}
        staticContent={currentStaticContent}
        customSize={props.customSize}
        removeStatic={removeStatic}
      />
    </Fragment>
  );
};
export default DashboardContainer;
